import React from "react";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import { scrollToElem } from "../../../functions.js";
import { orderBy } from "lodash";
import * as Sentry from "@sentry/browser";

import MeasurementMoment from "./measurementMoment";
import { hasStaffRole } from "../../../utils/auth.jsx";
import { Tooltip } from "../../../components/Tooltip";
import { DontShowProgressAutomaticallyToolTip } from "./tooltips.jsx";

export default class EventsComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            dirtyForm: false,
            errorMessage: {},
            course: {},
            events: [],
            students: [],
            followUrl: "",
            splittedEvents: [],
            eventTemplates: [],
            eventDetails: [],
            dataTrainers: [],
            existingEventDetails: [],
            your_reference: false,
            showEventPopup: false,
            eventDialogVisible: false,
            eventDialogUUID: false,
            eventEditable: true,
            knowledgeExams: []
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            dirtyForm: true
        });
    };

    showEventDialog = (event) => {
        this.setState({
            eventDialogVisible: true,
            eventDialogUUID: event.uuid,
            eventEditable: event.is_editable
        });
    };

    closeEventDialog = () => {
        this.setState({
            eventDialogVisible: false,
            eventDialogUUID: false
        });

        this.getInitialData();
    };

    passValuesToParent = (values) => {
        this.getAvailableLocations();
        let eventDetails = this.state.eventDetails;

        // Check if we already have details for this event, if so, update them
        if (eventDetails.find((evt) => evt.template === values.template)) {
            eventDetails = eventDetails.map((eventDetail) => {
                if (eventDetail.template === values.template) {
                    return {
                        ...values,
                        event_roles: [
                            {
                                ...values.event_roles[0],
                                instructors: values && values.event_roles && values.event_roles[0].instructors ? values.event_roles[0].instructors : []
                            }
                        ]
                    };
                }
                return eventDetail;
            });
        } else {
            eventDetails.push({
                ...values,
                event_roles: [
                    {
                        ...values.event_roles[0],
                        instructors: values && values.event_roles && values.event_roles[0].instructors ? values.event_roles[0].instructors : []
                    }
                ]
            });
        }

        this.setState({
            eventDetails: eventDetails
        });

        this.updateEvents(eventDetails);
    };

    toggleSplittedEvent = (uuid) => {
        let splittedEvents = this.state.splittedEvents;
        let index = splittedEvents.indexOf(uuid);

        if (index > -1) {
            splittedEvents.splice(index, 1);
        } else {
            splittedEvents.push(uuid);
        }

        this.setState({
            splittedEvents
        });
    };

    updateEvents = (eventDetails = null) => {
        let eventTemplates = this.state.eventTemplates;
        if (!eventDetails) {
            eventDetails = this.state.eventDetails;
        }
        const courseEventsURL = `/v1/courses/${this.props.params.itemID}/events/`;

        // After hitting save we want to store all the events for this course that are filled out
        // - Check if an event already exists, if yes, patch it
        // - When it doesn't exist, post it
        let requests = [];
        eventTemplates.forEach((eventTemplate) => {
            // Check here if we need to save the parent or the children
            // Only the children of the item where the parent is splitted
            let eventDetail = eventDetails.find((evt) => evt.template === eventTemplate.uuid);

            if (eventDetail) {
                if (eventDetail.uuid !== null) {
                    if (eventDetail.is_editable) {
                        requests.push(axios.patch(`${courseEventsURL}${eventDetail.uuid}/`, eventDetail));
                    }
                } else {
                    requests.push(axios.post(courseEventsURL, eventDetail));
                }
            }
        });

        axios
            .all(requests)
            .then((results) => {
                this.props.addGlobalMessage({
                    title: `De toetsmomenten van cursus '${this.state.course.display_name}' zijn succesvol opgeslagen`,
                    link: `/courses/edit/${this.props.params.itemID}/events`
                });

                let temp = results.map((r) => r.data);
                this.getInitialData();
            })
            .catch((error) => {
                this.setState({
                    errorMessage: error.response?.data
                });
                scrollToElem(document.querySelector(".form-error"));
            });
    };

    componentDidMount = () => {
        this.getInitialData();
    };

    getInitialData = () => {
        // Get competenceprofile data to choose from and the course data itself
        axios
            .get("/v1/courses/" + this.props.params.itemID + "/")
            .then((course) => {
                axios
                    .all([
                        axios.get(
                            "/v1/competenceprofiles/" + course.data.competence_profile + "/eventtemplates/?is_active=1&fields=uuid,name,parent,prerequisites,roles,type"
                        ),
                        axios.get("/v1/courses/" + this.props.params.itemID + "/events/")
                        // axios.get("/v1/trainers/?fields=uuid,name&pagination=false&is_active=1")
                    ])
                    .then(
                        axios.spread((eventTemplates, events) => {
                            let splittedEvents = [];
                            if (eventTemplates.data && eventTemplates.data.results) {
                                eventTemplates.data.results.forEach((template) => {
                                    if (
                                        template.parent !== null &&
                                        !splittedEvents.find((evt) => evt === template.parent) &&
                                        events.data.results.find((evt) => evt.template === template.uuid)
                                    ) {
                                        splittedEvents.push(template.parent);
                                    }
                                });
                            }

                            const eventDetails = events.data.results;
                            // Johan 2021-02-03:
                            // Everything is mapped to the same variables? Why?

                            // let eventDetails = events.data.results.map((event) => {
                            //   return {
                            //     ...event,
                            //     name: event.name,
                            //     uuid: event.uuid,
                            //     trainer: event.trainer,
                            //     course: event.course,
                            //     location: event.location,
                            //     template: event.template,
                            //     is_editable: event.is_editable,
                            //     start_datetime: event.start_datetime,
                            //     end_datetime: event.end_datetime,
                            //     knowledge_exam_name: event.knowledge_exam_name,
                            //     knowledge_exam_available: event.knowledge_exam_available,
                            //     event_roles: [
                            //       {
                            //         template: event.event_roles && event.event_roles.length > 0 ? event.event_roles[0].template : null,
                            //         instructors: event.event_roles && event.event_roles.length > 0 ? event.event_roles[0].instructors : []
                            //       }
                            //     ],
                            //     type: event.type
                            //   };
                            // });

                            this.setState({
                                course: course.data,
                                events: events.data.results,
                                students: course.data.students,
                                your_reference: `${course.data.id} - ${course.data.your_reference}`,
                                eventTemplates: eventTemplates.data.results,
                                eventDetails: eventDetails,
                                existingEventDetails: eventDetails,
                                splittedEvents: splittedEvents,
                                // Johan 2021-08-31: As trainers can't be changed for a course we simply pass the current trainer:
                                dataTrainers: [course.data.trainer_details]
                            });
                            this.getAvailableLocations();
                            // this.getEventResults();
                        })
                    )
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getAvailableLocations = () => {
        if (this.state.course && this.state.course.trainer) {
            axios.get("/v1/locations/?company=" + this.state.course.trainer + "&is_active=1&pagination=false&fields=name,uuid").then((locations) => {
                this.setState({
                    availableLocations: locations.data
                });
            });
        }
    };

    getData = () => {
        axios.get("/v1/courses/" + this.props.params.itemID + "/events/").then((events) => {
            this.setState({
                events: events.data.events
            });
        });
    };

    // getEventResults = () => {
    //     let stateEventDetails = orderBy(this.state.eventDetails, ["start_datetime", "name"], ["asc"]);
    //     let eventAllResults = [];
    //
    //     stateEventDetails.forEach((currentEvent) => {
    //         this.state.students.forEach((currentStudent) => {
    //             axios
    //                 .get("/v1/courses/" + this.props.params.itemID + "/students/" + currentStudent.uuid + "/results/?event=" + currentEvent.uuid)
    //                 .then((eventResults) => {
    //                     let notAchievedResults = eventResults.data.results.filter((e) => e.score_type_slug === "not_achieved" || e.score_type_slug === "insufficient");
    //                     if (eventResults.data.results.length > 0 && notAchievedResults.length === 0) {
    //                         eventAllResults.push({
    //                             student: currentStudent.uuid,
    //                             event: currentEvent.uuid,
    //                             result: "achieved"
    //                         });
    //                     } else {
    //                         eventAllResults.push({
    //                             student: currentStudent.uuid,
    //                             event: currentEvent.uuid,
    //                             result: "not_achieved"
    //                         });
    //                     }
    //                 });
    //         });
    //     });
    //
    //     this.setState({
    //         eventResults: eventAllResults
    //     });
    // };

    /**
     * Fetches the event template with the specified UUID from the state.
     * @param {String} uuid
     * @returns {Object|null}
     */
    getEventTemplateByUUID(uuid) {
        return this.state.eventTemplates.find((item) => item.uuid === uuid);
    }

    render = () => {
        let eventDetails = [];
        let stateEventDetails = orderBy(this.state.eventDetails, ["start_datetime", "name"], ["asc"]);
        const isNIBHVUser = hasStaffRole(this.props.authentication?.user?.roles || []);

        stateEventDetails.forEach((currentEvent) => {
            // find the template
            const template = this.getEventTemplateByUUID(currentEvent.template);

            if (!template) {
                // event without a template? Shouldn't be possible.
                return;
            }

            const eventIsSplit = this.state.splittedEvents.find((item) => item === template.uuid);

            if (!eventIsSplit) {
                eventDetails.push(
                    <EventRow
                        isNIBHVUser={isNIBHVUser}
                        key={currentEvent.uuid}
                        event={currentEvent}
                        template={template}
                        // eventResults={this.state.eventResults}
                        onClick={() => this.showEventDialog(currentEvent)}
                    />
                );
            } else {
                // Get the children of this template
                this.state.eventTemplates
                    .filter((item) => item.parent === template.uuid)
                    .forEach((template) => {
                        eventDetails.push(
                            <EventRow
                                isNIBHVUser={isNIBHVUser}
                                key={currentEvent.uuid}
                                event={currentEvent}
                                template={template}
                                // eventResults={this.state.eventResults}
                                onClick={() => this.showEventDialog(currentEvent)}
                            />
                        );
                    });
            }
        });

        if (!eventDetails.length) {
            eventDetails.push(
                <tr key={"eventdetails-loading"}>
                    <td colSpan="5">Evenementen ophalen...</td>
                </tr>
            );
        }

        const eventEditable = this.state.eventEditable && !this.state.course.is_cancelled;

        return (
            <div className="row">
                <div className="col-12 mt-5">
                    <h2 className="h1 mb-3">Toetsmomenten</h2>

                    <div className="row">
                        <div className="col-5">
                            <div>
                                Toon tijdens cursus cursist voortgang in Mijn NIBHV
                                <DontShowProgressAutomaticallyToolTip />
                            </div>
                        </div>
                        <div className="col-7">
                            <div className="header-account-menu__icon course_toggle">{this.props.activateItem}</div>
                        </div>
                    </div>

                    {this.state.course.is_cancelled && (
                        <div className="alert alert-info">Deze cursus is geannuleerd, toetsmomenten kunnen niet langer worden aangepast</div>
                    )}

                    <div className="mt-3 mb-5">
                        <table className="table table-hover table-clickable coursedetail-overview">
                            <thead>
                                <tr>
                                    <th width="120" className={"coursedetail-overview__sort-column"}>
                                        Datum
                                    </th>
                                    <th>Toetsmoment</th>
                                    <th>Soort toets</th>
                                    <th width="80">Aanwezig</th>
                                    <th width="40">Resultaten bekend?</th>
                                    {isNIBHVUser && <th width="40">Controleur</th>}
                                    <th width="40" />
                                </tr>
                            </thead>
                            <tbody>{eventDetails}</tbody>
                        </table>
                    </div>
                </div>

                <MeasurementMoment
                    {...this.props}
                    visible={this.state.eventDialogVisible}
                    eventUUID={this.state.eventDialogUUID}
                    courseUUID={this.state.course.uuid}
                    trainerUUID={this.state.course.trainer}
                    course={this.state.course}
                    events={this.state.events}
                    parentGetEvents={this.getData}
                    splittedEvents={this.state.splittedEvents}
                    allTrainersData={this.state.dataTrainers}
                    eventTemplates={this.state.eventTemplates}
                    editable={eventEditable}
                    passValuesToParent={this.passValuesToParent}
                    availableLocations={this.state.availableLocations}
                    closeStudentDialog={this.closeEventDialog}
                />
            </div>
        );
    };
}

const eventTypeNames = {
    elearning: "E-learning",
    practice: "Praktijk toetsmoment",
    "knowledge-exam": "Kennisexamen"
};

/**
 * Displays a row with event details. Used in EventsComponent.
 * @param {Object} event
 * @param {Object} template
 * @param {String[]} [warnings]
 * @param props
 * @returns {JSX.Element}
 */
function EventRow({ event, isNIBHVUser, template, warnings, ...props }) {
    const now = new Date();
    const knowledgeExamAvailable = event.type === "knowledge-exam" && event.knowledge_exam_name ? moment(event.knowledge_exam_available?.from_datetime) : null;

    let studentCountDisplay = ["practice", "knowledge-exam"].includes(event.type) ? `${event.attended_student_count} / ${event.student_count}` : "N.v.t.";

    // If the event has yet to start and is practice / knowledge exam, show will attend students
    if (["practice", "knowledge-exam"].includes(event.type) && event.result !== "achieved") {
        studentCountDisplay = `${event.attending_student_count} / ${event.student_count}`;
    }
    // Check if the event has results, if that is the case, show only the number of attended students
    // We show the actual attended students and the expected attended students
    if (event.has_results) {
        studentCountDisplay = `${event.attended_student_count} / ${event.student_count}`;
    }

    // number of assessed roles:
    const roleCount = event.event_roles.length;
    const assessedRoles = event.type === "elearning" ? 0 : event.event_roles.reduce((count, role) => count + (role.assessed ? 1 : 0), 0);

    const classNames = props.className ? props.className.split(" ") : [];
    if (!warnings) {
        const isPractice = event.type === "practice";
        const isELearning = event.type === "elearning";
        // const endedInPast = moment(event.end_datetime).isBefore();

        warnings = [];
        if (isPractice && !event.location) {
            warnings.push("Dit toetsmoment mist een locatie.");
        }
        if (!isELearning && !event.event_roles.every((role) => !!role.instructors && role.instructors.length)) {
            warnings.push("Dit toetsmoment mist instructeur(s).");
        }
        // if (!isELearning && endedInPast && !event.event_roles.every((role) => role.assessed)) {
        //     warnings.push("Dit toetsmoment is afgelopen maar er zijn nog geen resultaten bekend.");
        // }
    }

    let toolTip = null;
    let warningText = null;

    if (warnings && warnings.length) {
        classNames.push("row-warning");
        // toolTip = <Tooltip type="warning" identifier={event.uuid} tooltip={<ul>{warnings.map((w, i) => <li key={i}>{w}</li>)}</ul>} />;
        warningText = (
            <ul className={"warning-list"}>
                {warnings.map((w, i) => (
                    <li key={i}>{w}</li>
                ))}
            </ul>
        );
    }

    // Johan: This isn't true, once there's a single measurement result the event
    // becomes not editable. Not all roles have to be assessed for that to happen.
    // if(!event.is_editable && assessedRoles < roleCount) {
    //     // This situation should not exist. Events can only be closed (Become non-editable) when all Roles are assessed
    //     Sentry.captureMessage("Event is not editable, but not all roles are assesed. This should not be possible", {
    //         extra: {
    //             uuid: event.uuid,
    //             assessedRoles,
    //             roleCount,
    //             event,
    //         }
    //     });
    // }

    const allStudentsExempted = () =>
        event?.event_roles?.length &&
        moment(event.end_datetime).isBefore(moment()) &&
        event?.event_roles?.every((role) => role?.students?.length && role?.students?.every((s) => s.is_exempt));

    const resultsAreKnown = event.has_results || (event.type !== "elearning" && assessedRoles === roleCount) || allStudentsExempted();

    return (
        <tr className={classNames.join(" ")} {...props}>
            <td>
                {event.start_datetime ? moment(event.start_datetime).format("DD-MM-YYYY") : "n.n.b."}
                {toolTip}
            </td>
            <td className={"coursedetail-overview__main-column"}>
                {template.name}
                <br />
                <span className="lighter">
                    {knowledgeExamAvailable &&
                        (knowledgeExamAvailable.isSameOrBefore(now, "day")
                            ? `${event.knowledge_exam_name}`
                            : `Beschikbaar op ${knowledgeExamAvailable.format("DD-MM-YYYY")}`)}

                    {!event.knowledge_exam_name && event.type === "knowledge-exam" && (
                        <div className="alert alert-warning">
                            <p>
                                <strong>Het kennisexamen is niet ingesteld, neem contact op met de beheerder.</strong>.
                            </p>
                        </div>
                    )}
                </span>
                {event.has_results && (
                    <span className="lighter">
                        <br />
                        Dit toetsmoment heeft al resultaten en kan niet meer worden aangepast
                    </span>
                )}
                {warningText}
            </td>
            <td>{eventTypeNames[event.type]}</td>
            <td>{studentCountDisplay}</td>
            <td>{resultsAreKnown ? "Ja" : assessedRoles === 0 ? "Nee" : `${assessedRoles} / ${roleCount}`}</td>
            {isNIBHVUser && <td>{event.event_roles.some((role) => role.auditor != null) && <i className="fa fa-bell" />}</td>}
            <td>
                <i className="fa fa-edit" title={"Bewerk dit toetsmoment"} />
            </td>
        </tr>
    );
}
EventRow.propTypes = {
    event: PropTypes.object,
    template: PropTypes.object
    // eventResults: PropTypes.array
};
